import * as betgalaxy from './Propositions.styles.betgalaxy';
import * as betprofessor from './Propositions.styles.betprofessor';
import * as betroyale from './Propositions.styles.betroyale';
import * as fiestabet from './Propositions.styles.fiestabet';
import * as puntcity from './Propositions.styles.puntcity';
import * as puntgenie from './Propositions.styles.puntgenie';
import * as questbet from './Propositions.styles.questbet';
import * as sterlingparker from './Propositions.styles.sterlingparker';
import * as vikingbet from './Propositions.styles.vikingbet';
import * as volcanobet from './Propositions.styles.volcanobet';
import * as wellbet from './Propositions.styles.wellbet';
import * as goldenrush from './Propositions.styles.goldenrush';
import * as juicybet from './Propositions.styles.juicybet';
import * as forsport from './Propositions.styles.forsport';
import * as junglebet from './Propositions.styles.junglebet';
import * as oldgill from './Propositions.styles.oldgill';
import * as buffalobet from './Propositions.styles.buffalobet';
import * as sugarcastle from './Propositions.styles.sugarcastle';
import * as gigabet from './Propositions.styles.gigabet';
import * as goldenbet888 from './Propositions.styles.goldenbet888';
import * as slambet from './Propositions.styles.slambet';
import * as betstride from './Propositions.styles.betstride';
import * as hyperbet from './Propositions.styles.hyperbet';
import * as chromabet from './Propositions.styles.chromabet';
import * as templebet from './Propositions.styles.templebet';
import * as titanbet from './Propositions.styles.titanbet';
import * as bet777 from './Propositions.styles.bet777';
import * as bet575 from './Propositions.styles.bet575';
import * as epicodds from './Propositions.styles.epicodds';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  bet777,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  oldgill,
  buffalobet,
  sugarcastle,
  gigabet,
  goldenbet888,
  slambet,
  betstride,
  hyperbet,
  chromabet,
  templebet,
  titanbet,
  bet575,
  epicodds,
};
